import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { sendEmail } from '../../lib/api/send-email'
import { Files } from '../../lib/constants/files'
import { CseFilter, CseInput, CseRequest, CseTypes } from '../../lib/types/models/cse/cse'
import { SendEmailInput } from '../../lib/types/models/mail/create-mail-attachment'
import { UpdateInput } from '../../lib/types/utils'
import { uploadFile } from '../../lib/utils/functions/file.functions'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const createCse = async (data: CseInput) => {
  if (data.logo) {
    const file = await uploadFile(Files.CSE_LOGO, data.logo)
    if (!file) throw new Error('File not uploaded')
    data.logo = file
  }
  return restApiClient.url(API.cse.create.url).post<CseTypes.Cse, CseInput>(data)
}

export const getAllCses = (input?: PaginationRequest<CseFilter>) => {
  return restApiClient
    .url(encodeNestedObject<PaginationRequest<CseFilter>>(API.cse.getAll.url, input))
    .get<PaginationResponse<CseTypes.Cse>>()
}

export const getCse = (id: number) => {
  return restApiClient.url(constructApiUrl(API.cse.get.url, { id })).get<CseTypes.Cse>()
}

export const updateCse = async (data: UpdateInput<CseRequest>) => {
  const { id, ...res } = data

  if (res.logo) {
    const file = await uploadFile(Files.CSE_LOGO, res.logo)
    if (!file) throw new Error('File not uploaded')
    res.logo = file
  }

  return restApiClient
    .url(constructApiUrl(API.cse.update.url, { id }))
    .patch<CseTypes.Cse, Partial<CseInput>>(res)
}

export const generateCodePartner = () => {
  return restApiClient
    .url(constructApiUrl(API.cse.generateCodePartner.url, null))
    .get<{ code: string }>()
}

export const deleteCse = (id: number) => {
  return restApiClient.url(constructApiUrl(API.cse.delete.url, { id })).delete()
}

export const closeCatalog = (id: number) => {
  return restApiClient.url(constructApiUrl(API.cse.closeCatalog.url, { id })).post()
}

export const openCatalog = (id: number) => {
  return restApiClient.url(constructApiUrl(API.cse.openCatalog.url, { id })).post()
}

export const sendCodeToPartners = (ids: number[]) => {
  return restApiClient.url(API.cse.sendCodeToPartners.url).post({ ids })
}

export const sendEmailToCse = (input: SendEmailInput) => {
  return sendEmail(API.cse.sendEmail.url, input)
}
